import { useLogService } from '../../../../hooks/useLogService';
import { Origin } from './Amelia.types';
import { AmeliaV2 } from './components/AmeliaV2/AmeliaV2';
import { Modal } from './components/Modal/Modal';

type Props = {
  prompt?: string;
  onClose: () => void;
  origin: Origin;
};

export const Amelia = ({ prompt, onClose, origin }: Props) => {
  const { logEvent } = useLogService();

  logEvent('ai_opened', undefined, {
    prompt,
    origin,
    version: '2',
  });

  return (
    <Modal onClose={onClose}>
      <AmeliaV2 onClose={onClose} initialPrompt={prompt} />
    </Modal>
  );
};
